import { strings } from "../common/i18n";

const getNames = (ids, list) => {
    if (!Array.isArray(ids) || !Array.isArray(list)) return [];
    return ids
        .map((id) => list.find((item) => item.id === id)?.name)
        .filter(Boolean);
};

const buildChip = (key, categoryLabel, names, ids) => {
    const display = names.length > 0 ? names : ids.map(String);
    const truncated = display.slice(0, 2);
    const remaining = display.length - truncated.length;
    const label = remaining > 0
        ? `${categoryLabel}: ${truncated.join(", ")} +${remaining}`
        : `${categoryLabel}: ${truncated.join(", ")}`;
    const tooltip = remaining > 0
        ? `${categoryLabel}: ${display.join(", ")}`
        : null;
    return { key, label, tooltip };
};

/**
 * Returns an array of { key, label, tooltip } descriptors for non-default
 * filter criteria on the audit. Handles both camelCase (legacy) and
 * snake_case (API) key formats. Returns empty array when filter is null.
 */
export const getAuditFilterChips = (filter, typesList) => {
    if (!filter) return [];
    const chips = [];

    // snake_case (API) or camelCase (legacy)
    const makes        = filter.makes                                          ?? [];
    const assetTypes   = filter.asset_types   ?? filter.assetTypes            ?? [];
    const categories   = filter.categories                                     ?? [];
    const financeTypes = filter.finance_types ?? filter.financeTypes           ?? [];

    const isNew  = filter.conditions?.is_new  ?? filter.conditions?.isNew  ?? true;
    const isUsed = filter.conditions?.is_used ?? filter.conditions?.isUsed ?? true;

    const randomSampling = filter.random_value_sampling  ?? filter.randomValueSampling  ?? 100;
    const monetaryValue  = filter.monetary_value_sampling ?? filter.monetaryValueSampling ?? 0;

    if (makes.length > 0) {
        chips.push(buildChip("makes", strings("makes"), getNames(makes, typesList?.makes?.data), makes));
    }
    if (assetTypes.length > 0) {
        chips.push(buildChip("assetTypes", strings("assetTypes"), getNames(assetTypes, typesList?.assetTypes?.data), assetTypes));
    }
    if (categories.length > 0) {
        chips.push(buildChip("categories", strings("categories"), getNames(categories, typesList?.categories?.data), categories));
    }
    if (financeTypes.length > 0) {
        chips.push(buildChip("financeTypes", strings("financeTypes"), getNames(financeTypes, typesList?.financeTypes?.data), financeTypes));
    }

    // Condition — only show when not the default (both Used & New)
    if (isUsed && !isNew) {
        chips.push({ key: "condition", label: `${strings("condition")}: ${strings("used")}`, tooltip: null });
    } else if (!isUsed && isNew) {
        chips.push({ key: "condition", label: `${strings("condition")}: ${strings("new")}`, tooltip: null });
    }

    // Sampling — only show when not the default (100%)
    if (typeof randomSampling === "number" && randomSampling < 100) {
        chips.push({ key: "sampling", label: `Sampling: ${randomSampling}%`, tooltip: null });
    }

    // Monetary value — only show when set
    if (typeof monetaryValue === "number" && monetaryValue > 0) {
        chips.push({ key: "monetary", label: `Min value: ${monetaryValue}`, tooltip: null });
    }

    return chips;
};
